import React from "react";
import { icWarningPopup } from "../image/image-src";
import Icon from "../image/Icon";

interface ErrorPopupProps {
  message: string;
  description: string;
  onClose: () => void;
  buttonText?: string;
}

const ErrorPopup: React.FC<ErrorPopupProps> = ({ message, description, onClose,buttonText }) => {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-60">
      <div className="bg-white rounded-2xl shadow-lg px-6 py-8 text-center max-w-sm w-full">
        <div className="mb-4 flex justify-center">
            <Icon src={icWarningPopup} />
        </div>
        <div className="text-lg font-bold text-[#0F172A] mb-2">{message}</div>
        <div className="text-sm text-[#334155] mb-6 whitespace-pre-line" >{description}</div>
        <button
          onClick={onClose}
          className="border border-blue-600 text-blue-600 px-6 py-2 rounded-xl hover:bg-blue-50 transition w-full"
        >
          {buttonText || "Close"}
        </button>
      </div>
    </div>
  );
};

export default ErrorPopup;